import { useDeviceSelectors } from 'react-device-detect';

export const useDetectDevice = () => {
  const [{ isDesktop, isMobile }] = useDeviceSelectors(window.navigator.userAgent);

  return { isDesktop, isMobile };
};
